// extracted by mini-css-extract-plugin
export default {"emojiIcon":"emoji-module__emojiIcon--Vu8EW","emojiContainer":"emoji-module__emojiContainer--UKG6Z"};